<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Add Disbursement</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="newFeeDetails" autocomplete="off">

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Fee Type</label>
        <select class="form-select" formControlName="feeId" (change)="setDefaults()">
          <option value="">Select Type</option>
          <option *ngFor="let fee of feeTypes" [value]="fee.id">{{fee.description}}</option>
        </select>
      </div>
      <div class="col-sm-6" *ngIf="newFeeDetails.controls['feeId'].value == 0">
        <label class="form-label fw-semibold">Description</label>
        <input class="form-control" formControlName="description">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Reference</label>
        <input class="form-control" formControlName="outlay_reference">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Date</label>
        <input type="date" class="form-control" formControlName="outlay_date">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Net Amount</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="netAmount" type="number">
        </div>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Supplier</label>
        <select class="form-select" formControlName="supplier_id">
          <option *ngFor="let supplier of supplierList" [value]="supplier.id">{{supplier.name}}</option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Account</label>
        <select class="form-select" formControlName="nominal_code">
          <option *ngFor="let account of officeAccountList" [value]="account.bank">{{account.bank}}</option>
        </select>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Method of Verification</label>
        <select class="form-select" formControlName="methodOfVerificationId">
          <option *ngFor="let method of methodsOfVerification" [value]="method.methodOfVerificationId">{{method.method}}</option>
        </select>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">

  <button *ngIf="!addingFee" type="button" class="btn btn-success"
    [disabled]="newFeeDetails.invalid" (click)="addFee()">Add</button>

  <button *ngIf="addingFee" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Adding...
  </button>
</div>